import { render, staticRenderFns } from "./newsMedia.vue?vue&type=template&id=c52fb5ec&scoped=true"
import script from "./newsMedia.vue?vue&type=script&lang=js"
export * from "./newsMedia.vue?vue&type=script&lang=js"
import style0 from "./newsMedia.vue?vue&type=style&index=0&id=c52fb5ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52fb5ec",
  null
  
)

export default component.exports